import React from 'react';
import styled from 'styled-components/macro';
import { useHistory, useParams } from 'react-router';
import { Typography } from '@deeptrue-frontend/ui';
import { useFormatMessage } from 'components/IntlProvider';
import { PackageInfoType } from 'store/modules/projects/projects.types';

const Wrapper = styled.div`
  padding: 1.5rem;
  background-color: white;
  display: flex;
  justify-content: center;
  flex-direction: column;
  border: 1px solid #e3e5e8;
  margin-bottom: 0.875rem;
  border-radius: 0.375rem;
`;

const Separator = styled.div`
  background-color: #e3e5e8;
  height: 1px;
  width: 100%;
  margin-top: 0.875rem;
  margin-bottom: 1rem;
`;

const Cta = styled.button`
  color: #144bb8;
  text-align: center;
  cursor: pointer;
  outline: none;
  border: none;
  background-color: transparent;
  font-size: 1rem;
  font-weight: 500;
`;

interface Props {
  packageInfo?: PackageInfoType;
  subscription?: null | any;
}

const PaymentReminder = ({ packageInfo, subscription }: Props) => {
  const t = useFormatMessage();
  const history = useHistory();
  const { id } = useParams<{ id: string }>();

  const isSubscriptionActivated = !!subscription;
  return (
    <Wrapper>
      <Typography variant="copy1" mb="1.25rem" weight="medium">
        {t('project.customerSatisfaction.payments.title', 'Your Payments')}
      </Typography>
      {isSubscriptionActivated && packageInfo ? (
        <Typography mt="0.5rem" mb="0.5rem" weight="medium" variant="copy2">
          <span>
            {t(
              'project.customerSatisfaction.packageInfo.nexPayment',
              'Next payment:'
            )}
          </span>
          <br />
          <span>
            {t(
              'project.customerSatisfaction.packageInfo.paymentOn',
              'CHF{nbsp}{value} on {date}',
              {
                nbsp: '\u00A0',
                value: packageInfo.next_payment_price,
                date: packageInfo.next_payment_date,
              }
            )}
          </span>
        </Typography>
      ) : (
        <>
          <Typography variant="copy2" weight="medium">
            {t(
              'project.customerSatisfaction.payments.card.missing',
              "You didn't provide your credit card details yet"
            )}
          </Typography>
          <Separator />
          <Cta
            onClick={() =>
              history.push(`/project/${id}/subscriptions?add_card=true`)
            }
          >
            {t(
              'project.customerSatisfaction.payments.card.add',
              'Add your credit card details'
            )}
          </Cta>
        </>
      )}
    </Wrapper>
  );
};

export default PaymentReminder;
